export function formatDateUnix(timestampSeconds) {
    const date = new Date(Number(timestampSeconds) * 1000);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC',
    };
    return date.toLocaleString('ru-RU', options);
}


